/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    heading: "heading",
    container: "container",
    indented: "container--indented",
};
export const SLOTS = {
    parentItem: "parent-item",
};
//# sourceMappingURL=resources.js.map
